import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import WhyUs from './components/WhyUs';
import Mission from './components/Mission';
///import Works from './components/Works';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Imprint from './components/Imprint';
import Privacy from './components/Privacy';

function App() {
  const [currentHash, setCurrentHash] = useState('');

  useEffect(() => {
    // Set initial hash
    setCurrentHash(window.location.hash);

    // Update hash on change
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Render legal pages when their hash is present
  if (currentHash === '#imprint') {
    return <Imprint />;
  }

  if (currentHash === '#privacy') {
    return <Privacy />;
  }

  // Default home page
  return (
    <StyledApp>
      <Navigation />
      <Hero />
      <WhyUs />
      <Mission />
      {/* <Works /> */}
      {/* <Testimonials /> */}
      <FAQ />
      <Footer />
    </StyledApp>
  );
}

const StyledApp = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: var(--color-dark-600);
`;

export default App;
